export default __webpack_public_path__ + "522c6514718b3d08bfbffae654c6003e.png";